module.exports = __webpack_public_path__ + "static/Motherson_BG-160490bd0dd0ceac3f9ceef846bfe988.jpg";